class utils {
    static isEmpty(val, str) {
        //判断是否为空的三中情况，undefined、null、空字符串
        return new Promise((resolve, reject) => {
            const [val1, val2] = [val, Object.is(val, '')];
            (val1 && !val2) ? resolve(val): reject(str);
        })
    }
    static isArrayEmpty(val, str) {
        //判断数组是否为空
        return new Promise((resolve, reject) => {
            const [val1, val2] = [val, Object.is(val.length, 0)];
            (val1 && !val2) ? resolve(val): reject(str);
        })
    }
    static isEquals(val1, val2, str = '两个值不相等') {
        //比较两个值、类型是否相等
        return new Promise((resolve, reject) => {
            Object.is(val1, val2) ? resolve(val1) : reject(str);
        })
    }
    static isLength(val, len, str) {
        return new Promise((resolve, reject) => {
            (val.length < len) ? reject(str): resolve(val);
        })
    }
    static isIp(val, str) {
        return new Promise((resolve, reject) => {
            const reg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
            (reg.test(val)) ? resolve(val): reject(str);
        })
    }
}
const openlayer = ({
    title = '新增',
    btn = ['确定', '取消'],
    area = ['700px', '450px'],
    content,
    success,
    btn1,
    btn2,
    end
}) => {
    layer.open({
        title: title,
        type: 1,
        area: area,
        btn: btn,
        btnAlign: 'c',
        shade:0.3,
        resize: false,
        content: content,
     //   zIndex: layer.zIndex, //重点1
        success: function(layero, index) {
           sessionStorage.layerIndex = index;
            success && success(index, layero);
       //      layer.setTop(layero); //重点2
        },
        btn1: function(index, layero) {
            btn1 && btn1(index, layero);
        },
        btn2: function(index, layero) {
            btn2 && btn2(index, layero);
        },
        end:function(index, layero){
            $("body").removeClass("overHide");
			$("html").removeClass("overHide");
			end && end(index, layero);
        }
    });
}

function closelayer(m = 200) {
    setTimeout(function() {
    	if(sessionStorage.layerIndex){
        layer.close(sessionStorage.layerIndex);
        sessionStorage.removeItem('layerIndex')
    	}else{
    		layer.closeAll();
    	}
        
    }, m)
}

function confirm(title = '您确定要删除吗？', callback) {
    layer.confirm(title, {
        title: '注意',
        btn: ['确定', '取消'],
        btnAlign: 'c',
        btn1: index => {
            callback && callback(index);
        }
    });
}
export {
    utils,
    openlayer,
    confirm,
    closelayer
}


// WEBPACK FOOTER //
// ./src/utils/utils.js